<template>
  <EdroneCard>
    <img
      src="https://d3vhsxl1pwzf0p.cloudfront.net/images_2_6/v2/logo.svg"
      width="100"
      class="center-block tw:mb-5"
      alt="Edrone logo"
    />
    <h4 class="bold text-center">
      {{ $_trans("This account has been suspended") }}
    </h4>
    <p class="text-center tw:mb-3">
      {{ $_trans("Your free trial is over") }}
    </p>

    <SuspensionModalButtons @click="goToPricing" />
  </EdroneCard>
</template>

<script setup>
import SuspensionModalButtons from "vue-app/components/Suspension/SuspensionModalButtons.vue";
import EdroneCard from "../../../assets/js/ui/EdroneCard.vue";

function goToPricing() {
  const lang = window.EDRONE_CONTEXT?.user?.lang;
  if (lang === "pl") {
    window.open("https://edrone.me/pl/cennik", "_blank");
    return;
  }
  if (lang === "pt") {
    window.open("https://edrone.me/pt/precos", "_blank");
    return;
  }
  window.open("https://edrone.me/pricing", "_blank");
}
</script>
